import AppBadge from "./AppBadge";

export default AppBadge;
export type { AppBadgeProps } from "./AppBadge";
